<template>
    <div>
        <div class="container-fluid">
            <div class="row" v-if="candidates.length">
                <div class="col-md-8" ref="infoBox" id="info-box">
                    <form action="">
                        <div class="filter-box">
                            <div class="row">
                                <div class="col-md-8">

                                </div>
                                <div class="col-md-4">
                                    <div class="text-right-btn">
                                        <router-link class="filter-btn" to="/dashboard/manage-loan-applicants">
                                            View Complete Detail
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="divider2"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="row">
                                <div>
                                    <div class="col-md-4 col-sm-6" v-for="c in candidates">
                                        <div class="new-cand-box" @click="showData($event)" :data-id="c.loan_app_enc_id"
                                             :data-semester="c.semesters" :data-dob="c.applicant_dob"
                                             :data-city="c.applicant_current_city" :data-degree="c.degree">
                                            <div class="row">
                                                <div class="col-md-4 col-sm-4 col-xs-4">
                                                    <div class="new-cand-icon">
                                                        <img :src="c.image" alt="">
                                                    </div>
                                                </div>
                                                <div class="col-md-8 col-sm-8 col-xs-8">
                                                    <div class="new-cand-details">
                                                        <div class="new-cand-name">{{ c.applicant_name }}</div>
                                                        <div class="new-cand-course">{{ c.course_name }}</div>
                                                        <div class="new-cand-course" v-if="c.semesters == 1">1st
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 2">2nd
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 3">3rd
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 4">4th
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 5">5th
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 6">6th
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 7">7th
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 8">8th
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 9">9th
                                                            Semester
                                                        </div>
                                                        <div class="new-cand-course" v-if="c.semesters == 10">10th
                                                            Semester
                                                        </div>
                                                        <!--<div class="new-cand-course">{{c.amount}}</div>-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row position-bottom">
                                                <div class="col-md-6 col-sm-6 col-xs-6">
                                                    <div class="new-cand-sem" v-if="c.status == 0">
                                                        <span>Pending</span>
                                                    </div>
                                                    <div class="new-cand-sem" v-if="c.status == 1">Verified</div>
                                                    <div class="new-cand-sem" v-if="c.status == 2">Rejected</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 height-100 cand-detail-main" id="cand-detail-main" v-if="user_detail != null">
                    <div v-bind:style="leftColStyles">
                        <div class="detail-box">
                            <div class="jobIocns stCards close-cand-details" @click="closeCandDetail()">
                                <div class="tooltip-main text-white">
                                    <i class="fas fa-times"></i>
                                </div>
                            </div>
                            <div class="db-two">
                                <div class="scroll-box">
                                    <div class="scroll-slim">
                                        <div class="col-md-12">
                                            <div class="new-detail-icon icon-center">
                                                <img :src="user_detail.image"/>
                                            </div>
                                            <div class="new-detail-name left-detail margin-top-20">
                                                {{ user_detail.applicant_name }}
                                            </div>
                                            <div class="new-detail-course left-detail"> {{ user_detail.course_name }} -
                                                <span v-if="user_detail.semesters == 1">1st Semester</span>
                                                <span v-if="user_detail.semesters == 2">2nd Semester</span>
                                                <span v-if="user_detail.semesters == 3">3rd Semester</span>
                                                <span v-if="user_detail.semesters == 4">4th Semester</span>
                                                <span v-if="user_detail.semesters == 5">5th Semester</span>
                                                <span v-if="user_detail.semesters == 6">6th Semester</span>
                                                <span v-if="user_detail.semesters == 7">7th Semester</span>
                                                <span v-if="user_detail.semesters == 8">8th Semester</span>
                                                <span v-if="user_detail.semesters == 9">9th Semester</span>
                                                <span v-if="user_detail.semesters == 10">10th Semester</span>
                                            </div>
                                            <!--                                            <div class="new-detail-course left-detail">-->
                                            <!--                                                Loan Amount: <span>{{user_detail.amount}}</span>-->
                                            <!--                                            </div>-->
                                            <div class="new-detail-course left-detail">
                                                DOB: <span v-html="getDateString(user_detail.applicant_dob)"></span>
                                            </div>
                                            <div class="new-detail-course left-detail">
                                                Application Submitted on: <span
                                                v-html="getDateString(user_detail.submitted_date)"></span>
                                            </div>
                                            <div class="new-detail-course left-detail"
                                                 v-if="user_detail.status === '1'">
                                                Application Verified on: <span
                                                v-html="getDateString(user_detail.verified_date)"></span>
                                            </div>
                                            <!--                                            <div class="new-detail-course">-->
                                            <!--                                                Degree: <span>{{user_detail.degree}}</span>-->
                                            <!--                                            </div>-->
                                            <!--                                            <div class="new-detail-course list-data left-detail">-->
                                            <!--                                                Purpose: <span v-for="pr in user_detail.loanPurposes">{{pr.name}}</span>-->
                                            <!--                                            </div>-->
                                            <!--                                            <div class="new-detail-course">-->
                                            <!--                                                Location: <span-->
                                            <!--                                                    v-if="user_detail.applicant_current_city">{{user_detail.applicant_current_city}}</span><span-->
                                            <!--                                                    v-else>N/A</span>-->
                                            <!--                                            </div>-->
                                            <div class="coApplicant" v-for="co in user_detail.loanCoApplicants">
                                                <h4 class="margin-top-20">Borrower Details</h4>
                                                <div class="new-detail-course">
                                                    Name: <span>{{ co.name }}</span>
                                                </div>
                                                <div class="new-detail-course">
                                                    Relation: <span>{{ co.relation }}</span>
                                                </div>
                                                <!--                                                <div class="new-detail-course">-->
                                                <!--                                                    Employment Type:-->
                                                <!--                                                    <span v-if="co.employment_type == 0">Non Working</span>-->
                                                <!--                                                    <span v-if="co.employment_type == 1">Salaried</span>-->
                                                <!--                                                    <span v-if="co.employment_type == 2">Self Employed</span>-->
                                                <!--                                                </div>-->
                                                <!--                                                <div class="new-detail-course">-->
                                                <!--                                                    Annual Income: <span>{{co.annual_income}}</span>-->
                                                <!--                                                </div>-->
                                            </div>
                                            <div v-if="user_detail.status === '0'">
                                                <form id="feeDetails">
                                                    <h4 class="margin-top-20">Fee Detail for the Current Year</h4>
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="amount_paid">Fee Amount
                                                            Already Paid</label>
                                                        <input type="number" class="form-control" id="amount_paid"
                                                               placeholder="Enter Amount" name="amount_received"
                                                               min="0">
                                                    </div>
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="scholarship">Scholarship/
                                                            Grants</label>
                                                        <input type="number" class="form-control" id="scholarship"
                                                               placeholder="Enter Amount" name="scholarship" min="0">
                                                    </div>
                                                    <div class="form-group">
                                                        <label class="ep-input-label" for="amount_due">Fee Amount
                                                            Due</label>
                                                        <input type="number" class="form-control" id="amount_due"
                                                               placeholder="Enter Amount" name="amount_due" min="0">
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="view-com-btn text-center" v-if="user_detail.status === '0'">
                                                <a href="javascript:;" :data-key="user_detail.loan_app_enc_id"
                                                   @click="loanAction($event, 'approve', 'approve')">Accept</a>
                                                <a href="javascript:;" :data-key="user_detail.loan_app_enc_id"
                                                   @click="loanAction($event, 'reject', 'reject')" class="default">Reject</a>
                                            </div>
                                            <div class="view-com-btn text-center"
                                                 v-else-if="user_detail.status === '1'">
                                                <form id="feeDetails">
                                                    <div class="text-left">
                                                        <h4 class="margin-top-20">Fee Detail for the Current Year <span id="updateToggle" @click="updateToggle($event)">Update Fee Detail</span></h4>
                                                        <div class="form-group">
                                                            <label class="ep-input-label">Fee Amount Already
                                                                Paid</label>
                                                            <input type="number" class="form-control"
                                                                   placeholder="Enter Amount" id="amount_paid"
                                                                   name="amount_received" min="0"
                                                                   :value="user_detail.amount_received" disabled>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="ep-input-label">Scholarship/ Grants</label>
                                                            <input type="number" class="form-control"
                                                                   placeholder="Enter Amount" id="scholarship"
                                                                   name="scholarship" min="0"
                                                                   :value="user_detail.scholarship" disabled>
                                                        </div>
                                                        <div class="form-group">
                                                            <label class="ep-input-label">Fee Amount Due</label>
                                                            <input type="number" class="form-control" id="amount_due"
                                                                   placeholder="Enter Amount" name="amount_due" min="0"
                                                                   :value="user_detail.amount_due" disabled>
                                                        </div>
                                                    </div>
                                                </form>
                                                <a href="javascript:;" class="hidden" id="updateDetails"
                                                   :data-key="user_detail.loan_app_enc_id"
                                                   @click="loanAction($event, 'approve', 'Update')">Update</a>
                                                <a href="javascript:;" id="verified"
                                                   class="margin-top-20 display-inline-block">Verified By College</a>
                                            </div>
                                            <div class="view-com-btn text-center"
                                                 v-else-if="user_detail.status === '2'">
                                                <a href="javascript:;">Rejected</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12 text-center">
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">No Student have applied for education loans</h2>
                    <div id="loading-list">
                        <div class="loading-list"></div>
                        <div class="loading-list-ring"></div>
                    </div>
                </div>
            </div>
        </div>
        <div id="cand-detail-open" class="cand-detail-open"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

export default {
    data: function () {
        return {
            leftColStyles: {},
            isCourse: false,
            isSem: false,
            isJob: false,
            user_detail: '',
            candidates: '',
            courses: '',
            monthDict: {
                0: 'Jan',
                1: 'Feb',
                2: 'Mar',
                3: 'Apr',
                4: 'May',
                5: 'June',
                6: 'July',
                7: 'Aug',
                8: 'Sep',
                9: 'Oct',
                10: 'Nov',
                11: 'Dec',
            },
        }
    },
    mounted() {
        if (!this.$store.getters.getUser['education_loan']) {
            this.$router.push({path: '/dashboard'})
        }
        this.matchHeight();
        this.getApplicants();
    },
    methods: {
        matchHeight() {
            if (this.$refs.infoBox) {
                var heightString = this.$refs.infoBox.clientHeight + 'px';
                Vue.set(this.leftColStyles, 'height', heightString);
            }
        },
        showData: function (event,isOpen = true) {
            var t = this;
            var element;
            var rm_elem = document.getElementsByClassName('new-cand-box');
            for (var r = 0; r < rm_elem.length; r++) {
                if (rm_elem[r].classList.contains('active')) {
                    rm_elem[r].classList.remove('active');
                }
            }
            if(isOpen) {
                element = event.currentTarget;
            } else {
                element = event;
            }
            if (document.getElementById('feeDetails') && t.user_detail.loan_app_enc_id != t.$store.getters.getApplicantsById(element.getAttribute('data-id'))[0].loan_app_enc_id) {
                var elements = document.getElementById('feeDetails').elements;
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    item.value = "";
                }
            }
            if(isOpen){
                document.getElementById('cand-detail-open').classList.add('open');
                document.getElementById('cand-detail-main').classList.add('open');
            }
            element.classList.add("active");
            t.user_detail = t.$store.getters.getApplicantsById(element.getAttribute('data-id'))[0];
        },
        closeCandDetail(){
            document.getElementById('cand-detail-open').classList.remove('open');
            document.getElementById('cand-detail-main').classList.remove('open');
        },
        getApplicants() {
            var fadeTarget = document.getElementById("loading-list");
            if (fadeTarget) {
                fadeTarget.style.display = "block";
            }
            var t = this;
            showLoader();
            var url = this.$store.getters.getDomain;
            var user_id = this.$route.query.id;

            axios.post(`${url}api/v2/loans/college-student-loans`, {id: user_id}, {headers: requestHeaders()}).then(function (response) {
                document.getElementById("h-page-load").classList.add("hides");
                if (response['data']['response']['status'] == 200) {
                    t.candidates = response['data']['response']['data'];
                    t.$store.dispatch("setApplicants", t.candidates);
                    setTimeout(function () {
                        if (!user_id && document.getElementsByClassName('new-cand-box')[0]) {
                            t.showData(document.getElementsByClassName('new-cand-box')[0],false);
                            if (document.getElementById('feeDetails')) {
                                var elements = document.getElementById('feeDetails').elements;
                                for (var i = 0; i < elements.length; i++) {
                                    var item = elements.item(i);
                                    item.value = "";
                                }
                            }
                        } else {
                            t.user_detail = response['data']['response']['loan_detail'];
                        }
                        t.matchHeight();
                        $('.scroll-slim').perfectScrollbar();
                    }, 1000)
                    t.matchHeight();
                } else {
                    t.candidates = [];
                }
                if (fadeTarget) {
                    fadeTarget.style.display = "none";
                }
                hideLoader();
            });
        },
        getDateString(dateString) {
            var t = this;
            var currentDate = new Date(dateString);
            return currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
        },
        updateToggle(event) {
            let element = event.currentTarget;
            var elements = document.getElementById('feeDetails').elements;
            if (element.classList.contains('on')) {
                element.classList.remove('on');
                element.innerHTML = 'Update Fee Details';
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    item.disabled = true;
                }
                document.getElementById('updateDetails').classList.add('hidden');
                document.getElementById('verified').classList.remove('hidden');
            } else {
                element.classList.add('on');
                element.innerHTML = 'Cancel Update';
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    item.removeAttribute("disabled");
                    item.disabled = false;
                    document.getElementById('updateDetails').classList.remove('hidden');
                    document.getElementById('verified').classList.add('hidden');
                }
            }
        },
        loanAction(event, action, type) {
            this.closeCandDetail();
            var obj = {};
            if (action === 'approve') {
                var elements = document.getElementById('feeDetails').elements;
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    if (item.value != "") {
                        if (item.classList.contains('invalid')) {
                            item.classList.remove('invalid');
                        }
                        obj[item.name] = item.value;
                    } else {
                        if (!item.classList.contains('invalid')) {
                            item.classList.add('invalid');
                        }
                        return false;
                    }
                }
            }
            var t = this;
            showLoader();
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            obj['id'] = data_key;
            obj['action'] = action;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/loans/loan-change-status`, obj, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    toastr.success('Application ' + type + ' successfully', 'Success');
                }
                t.getApplicants();
            })
        },
    },
}
</script>

<style scoped>
.course-filter ul li {
    display: inline-block;
    padding: 0 0 0 15px;
}

.new-cand-icon {
    width: 80px;
    height: 80px;
}

.new-cand-sem span {
    background: #00a0e3;
    color: #fff;
    font-size: 12px;
    padding: 3px 10px 4px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
}
input[type=checkbox] {
    display: none;
}

input:checked + label {
    transition: .2s ease;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    color: #00a0e3;
}

/* new stuff */
.check {
    padding-top: 0px !important;
    visibility: hidden;
}

input:checked + label .check {
    visibility: visible;
}

input.checkbox:checked + label:before {
    content: "";
}

.text-right-btn {
    text-align: right;
    padding-right: 20px;
}

.detail-box {
    margin-top: 15px;
}

.loading-list {
    top: 0;
}

.coApplicant h4, #feeDetails h4 {
    margin-top: 20px !Important;
    font-weight: bold;
}
.new-cand-box.active {
    border: 1px solid #00a0e3;
}
.new-detail-course {
    font-weight: 500;
}

.new-detail-course span {
    font-weight: 400;
    color: #666;
    font-size: 16px;
}

.list-data span:after {
    content: ", ";
}

.list-data span:last-child:after {
    content: "";
}

.new-detail-icon {
    float: right;
}

.left-detail {
    max-width: calc(100% - 160px);
}
#updateToggle{
    font-weight: 100;
    font-size: 13px;
    float: right;
    color: #00a0e3;
    cursor: pointer;
}
.close-cand-details{
    display: none;
}
.view-com-btn a{
    display: inline-block;
}
@media screen and (max-width: 991px) {
    .cand-detail-main {
        display: none;
    }
    .detail-box{
        position: fixed;
        z-index: 999999;
        right: 5vw;
        top: 5vh;
        width: 90vw;
        height: 80vh;
        overflow: scroll;
        background-color: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);
        border-radius: 10px;
    }
    .scroll-box{
        height: auto;
    }
    .scroll-slim{
        position: relative;
        height: calc(100vh - 28vh);
    }
    .cand-detail-open{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 99999;
        background-color: #000;
        opacity: 0.6;
        display: none;
    }
    .cand-detail-open.open, .cand-detail-main.open,.close-cand-details{
        display: block;
    }
    .jobIocns.stCards.close-cand-details{
        background-color: red;
        width: 50px;
        height: 38px;
        line-height: 38px;
        font-size: 20px;
    }
}
</style>
